export default {"src":"/_next/static/media/tickets.f97f553c.svg","height":32,"width":25,"blurWidth":0,"blurHeight":0};